import React, { useEffect, useMemo } from 'react'
import { useGetCustomerSourceByCustomerSourceId } from '../../../../api/dealership/customers/sources/useGetCustomerSourceByCustomerSourceId'
import TextInput from '../../../../components/FormElements/TextInput'
import { Button } from '@demandlocal/components'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import { useInView } from 'react-intersection-observer'
import { useModal } from '../../../../components/useModal'
import { useEditCustomerSourceByCustomerSourceId } from '../../../../api/dealership/customers/sources/useEditCustomerSourceByCustomerSourceId'
import toast from 'react-hot-toast'

type Props = {
  customer_source_id: number
}
const EditManualSource = (props: Props): JSX.Element => {
  const { customer_source_id } = props
  const { closeModal } = useModal()
  const { data: source } = useGetCustomerSourceByCustomerSourceId(customer_source_id)
  const formContext = useForm({
    mode: 'onSubmit',
  })
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = formContext
  const [ref, inView, entry] = useInView({
    threshold: 1,
    triggerOnce: true,
    fallbackInView: true,
    delay: 500,
  })
  useEffect(() => {
    reset({
      source_name: source?.customer_source,
      saas_customer_source_type: [
        { label: 'Customer List', value: 1 },
        { label: 'Sold Report List', value: 2 },
      ].find((s) => s.value === source?.saas_customer_source_type),
    })
  }, [reset, source?.customer_source, source?.saas_customer_source_type])

  const { mutateAsync: editCustomerSource } = useEditCustomerSourceByCustomerSourceId()
  const onSubmit = async (values: Partial<FieldValues>): Promise<void> => {
    const toastId = toast.loading('Saving...')
    await editCustomerSource({
      data: {
        customer_source_id,
        customer_source: values.source_name,
        data_provider_id: 2,
      },
    })
    toast.success('Saved!', { id: toastId })
    closeModal()
  }
  return (
    <FormProvider {...formContext}>
      <form
        ref={ref}
        onSubmit={handleSubmit(onSubmit)}
        className={'flex flex-1 flex-col pt-12 font-Spartan h-full'}>
        <div className={'flex flex-1 flex-col  px-12 overflow-hidden'}>
          <div className={'font-bold text-[28px] text-primary-xiketic'}>
            Import CSV data
          </div>
          <div className={'pt-8'}>
            <div className={'w-1/2'}>
              <TextInput
                rules={{ required: 'This field is required' }}
                inverted
                placeholder={'Ex. CRM-download-import_Mar2022'}
                name={'source_name'}
                label={'Name your source'}
                control={control}
                info={'Give it a clear name so you remember it easily'}
              />
            </div>
          </div>
        </div>
        <div className={'h-20 px-12'}>
          <div className={'items-center flex justify-between border-t-2 py-4'}>
            <Button
              variant={'secondary'}
              disabled={isSubmitting}
              onClick={(e) => {
                e.preventDefault()
                closeModal()
              }}>
              Close
            </Button>
            <Button disabled={isSubmitting} type={'submit'}>
              Save
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

export default EditManualSource
